import React from 'react';

import FormattedTextField from './FormattedTextField';

export default function PlaceholderFieldValue(): JSX.Element {
  return <FormattedTextField text="N/A" />;
}
